import { Info } from 'lucide-react';
import { Tooltip } from './Tooltip';
import { cn } from '@lib/utils';

export interface InfoTooltipProps {
  content: string;
  position?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  iconClassName?: string;
}

export function InfoTooltip({ content, position = 'top', className, iconClassName }: InfoTooltipProps) {
  return (
    <Tooltip content={content} position={position} className={className}>
      <Info
        className={cn(
          'h-3.5 w-3.5 cursor-help text-gray-400 transition-colors hover:text-merino-600',
          iconClassName
        )}
        aria-label="Mas informacion"
      />
    </Tooltip>
  );
}
